import React, { useState } from 'react';

const WorkPage = () => {
  const [filter, setFilter] = useState('ALL');

  // YOUR FULL PROJECT DATABASE
  const projects = [
    {
      id: "01",
      title: "GYM TRAINER OS",
      client: "FitPulse Inc.",
      category: "SAAS",
      year: "2025",
      description: "A comprehensive business operating system for fitness trainers. We automated client scheduling, diet planning, and Stripe payments, reducing admin time by 60%.",
      stack: ["React", "Node.js", "MongoDB", "Stripe Connect"],
      image: "https://images.unsplash.com/photo-1534438327276-14e5300c3a48?q=80&w=1470&auto=format&fit=crop",
      link: "https://topfitness-mu.vercel.app"
    },
    {
      id: "02",
      title: "BEAUTY SPA",
      client: "Nebula Fashion",
      category: "ECOMMERCE",
      year: "2024",
      description: "A headless Shopify storefront built for extreme speed. Implemented advanced caching and image optimization to achieve a 99/100 Lighthouse score.",
      stack: ["Next.js", "Shopify API", "Redis", "Tailwind"],
      image: "https://images.unsplash.com/photo-1483985988355-763728e1935b?q=80&w=1470&auto=format&fit=crop",
      link: "https://salon-ecru.vercel.app/"
    },
    {
      id: "03",
      title: "JILAPI (RESTAURANT ERP PLATFORM)",
      client: "Jilapi Tech", // Updated to reflect your founder status
      category: "SAAS",      // Changed from MOBILE to SAAS for better positioning
      year: "2024",
      description: "A high-performance Restaurant ERP designed to stop inventory 'leakage' and automate supply chains. Features live margin tracking, automated stock alerts, and real-time sales analytics.",
      stack: ["React", "Node.js", "MongoDB", "Tailwind CSS"], // Updated to match your actual stack
      image: "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?q=80&w=2516&auto=format&fit=crop", // A much more professional POS/ERP image
      link: "https://jilapi.toporion.net" // Update this to your actual production URL
    },
    {
      id: "04",
      title: "ORGANIC FARM (E-AGRO ECOSYSTEM)",
      client: "GreenRoot Harvest",
      category: "ECOMMERCE", // Changed from WEB3 to ECOMMERCE to match the project type
      year: "2023",
      description: "A farm-to-table digital marketplace and supply chain tracker. Implemented real-time inventory management for perishable goods and a seamless subscription-based delivery system for organic produce.",
      stack: ["React", "Tailwind CSS", "Node.js", "MongoDB"],
      image: "https://images.unsplash.com/photo-1589923188900-85dae523342b?q=80&w=2670&auto=format&fit=crop",
      link: "https://organicfarm-tau.vercel.app/"
    },
  ];

  const filteredProjects = filter === 'ALL' ? projects : projects.filter(p => p.category === filter);
  const categories = ["ALL", "SAAS", "ECOMMERCE", "MOBILE", "WEB3"];

  return (
    <div className="min-h-screen bg-void text-white pt-24 pb-24">

      {/* 1. PAGE HEADER */}
      <div className="container mx-auto px-6 mb-20">
        <div className="border-b border-white/10 pb-8 flex flex-col md:flex-row items-end justify-between gap-6">
          <div>
            <span className="text-neon-blue font-mono text-sm tracking-widest uppercase mb-2 block">
              // Portfolio Archive
            </span>
            <h1 className="text-5xl md:text-8xl font-black font-display text-white">
              SELECTED <br />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-gray-500 to-white">WORKS</span>
            </h1>
          </div>

          <p className="text-gray-400 max-w-sm text-sm md:text-base leading-relaxed mb-2">
            A curation of digital products engineered for performance, scalability, and business impact.
          </p>
        </div>

        {/* 2. FILTER TABS (HUD STYLE) */}
        <div className="flex flex-wrap gap-4 mt-8">
          {categories.map(cat => (
            <button
              key={cat}
              onClick={() => setFilter(cat)}
              className={`px-6 py-2 rounded-full border text-xs font-mono font-bold tracking-widest transition-all duration-300 ${filter === cat
                ? 'bg-neon-blue text-black border-neon-blue shadow-[0_0_15px_rgba(0,240,255,0.4)]'
                : 'bg-transparent text-gray-500 border-white/10 hover:border-white hover:text-white'
                }`}
            >
              {cat}
            </button>
          ))}
        </div>
      </div>

      {/* 3. THE PROJECT LIST */}
      <div className="container mx-auto px-6">
        <div className="flex flex-col gap-32">

          {filteredProjects.map((project, index) => (
            <div
              key={project.id}
              className={`group flex flex-col ${index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'} gap-12 lg:gap-24 items-center`}
            >

              {/* IMAGE SECTION (The Visual) */}
              <div className="w-full lg:w-3/5 relative">
                {/* Decorative Frame */}
                <div className="absolute -inset-4 border border-white/5 rounded-3xl z-0 group-hover:border-neon-blue/20 transition-colors duration-500"></div>

                <div className="relative rounded-2xl overflow-hidden aspect-[16/10] shadow-2xl">
                  {/* Image */}
                  <img
                    src={project.image}
                    alt={project.title}
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                  />

                  {/* Overlay Gradient (Only visible on hover) */}
                  <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity duration-500 flex items-center justify-center">
                    <div className="w-20 h-20 rounded-full bg-neon-blue/90 text-black flex items-center justify-center font-bold tracking-widest text-xs backdrop-blur-md transform scale-50 group-hover:scale-100 transition-transform duration-500">
                      VIEW
                    </div>
                  </div>
                </div>
              </div>

              {/* DATA SECTION (The Informative Part) */}
              <div className="w-full lg:w-2/5 relative z-10">

                {/* ID Number */}
                <div className="text-8xl font-black text-white/5 font-display absolute -top-20 -left-10 z-0 select-none">
                  {project.id}
                </div>

                <div className="relative z-10">
                  {/* Header Info */}
                  <div className="flex items-center gap-4 mb-4">
                    <span className="px-2 py-1 bg-white/5 border border-white/10 rounded text-[10px] font-mono text-neon-blue font-bold tracking-widest uppercase">
                      {project.category}
                    </span>
                    <span className="text-gray-500 font-mono text-xs">
                            // {project.year}
                    </span>
                  </div>

                  <h2 className="text-4xl md:text-5xl font-black text-white mb-6 font-display leading-tight">
                    {project.title}
                  </h2>

                  <p className="text-gray-400 text-lg leading-relaxed mb-8">
                    {project.description}
                  </p>

                  {/* The "Data Grid" (Informative) */}
                  <div className="grid grid-cols-2 gap-y-6 gap-x-4 border-t border-white/10 pt-6 mb-8">
                    <div>
                      <h4 className="text-gray-500 text-xs font-mono uppercase tracking-widest mb-1">Client</h4>
                      <p className="text-white font-bold">{project.client}</p>
                    </div>
                    <div>
                      <h4 className="text-gray-500 text-xs font-mono uppercase tracking-widest mb-1">Tech Stack</h4>
                      <div className="flex flex-wrap gap-2">
                        {project.stack.map(tech => (
                          <span key={tech} className="text-xs text-gray-300 bg-white/5 px-2 py-1 rounded">
                            {tech}
                          </span>
                        ))}
                      </div>
                    </div>
                  </div>

                  {/* Action Button */}
                  <a href={project.link} className="inline-flex items-center gap-2 text-white font-bold border-b border-neon-blue pb-1 hover:text-neon-blue transition-colors">
                    LIVE SITE
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="w-4 h-4">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M17.25 8.25L21 12m0 0l-3.75 3.75M21 12H3" />
                    </svg>
                  </a>
                </div>
              </div>

            </div>
          ))}

        </div>

        {/* Bottom CTA */}
        <div className="mt-32 p-12 bg-surface border border-white/5 rounded-3xl text-center relative overflow-hidden">
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-neon-blue to-transparent opacity-50"></div>
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">Have a project in mind?</h2>
          <p className="text-gray-400 mb-8 max-w-xl mx-auto">We are currently accepting new missions for Q1 2026.</p>
          <a href="/contact" className="inline-block px-8 py-4 bg-neon-blue text-black font-bold uppercase tracking-widest rounded-lg hover:scale-105 transition-transform">
            Start a Project
          </a>
        </div>

      </div>
    </div>
  );
};

export default WorkPage;